import { Link, Navigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { PixelText } from '../ui/PixelText';
import { PixelButton } from '../ui/PixelButton';
import { PixelPanel } from '../ui/PixelPanel';
import { usePlayerStore } from '../store/player';

export function DailyChallenge() {
  const { t } = useTranslation();
  const me = usePlayerStore(s => s.me);
  if (!me) return <Navigate to="/login" replace />;

  return (
    <main className="min-h-screen flex flex-col gap-4 p-4">
      <div className="flex items-center gap-3">
        <Link to="/"><PixelButton variant="ghost" className="text-xs">{t('common.home')}</PixelButton></Link>
        <PixelText size="xl" color="yellow">{t('daily.title')}</PixelText>
      </div>

      <PixelPanel className="text-center">
        <PixelText size="base" color="yellow">{t('daily.todays_challenge')}</PixelText>
        <PixelText size="sm" color="cyan" className="block mt-1">
          {t('daily.theme_hint')}
        </PixelText>
      </PixelPanel>

      <PixelPanel>
        <PixelText size="sm" color="white">
          {t('daily.attempts_hint')}
        </PixelText>
      </PixelPanel>

      <Link to="/daily/today">
        <PixelButton className="w-full">{t('daily.battle')}</PixelButton>
      </Link>
    </main>
  );
}
